import { Typography } from '@material-ui/core';
import Breadcrumb from '../Breadcrumb';
import CreateDocument1 from './../../assets/CreateDocument-1.png';
import CreateDocument2 from './../../assets/CreateDocument-2.png';
import CreateDocument3 from './../../assets/CreateDocument-3.png';
import CreateDocument4 from './../../assets/CreateDocument-4.png';
import CreateDocument5 from './../../assets/CreateDocument-5.png';
import CreateDocument6 from './../../assets/CreateDocument-6.png';
import CreateDocument7 from './../../assets/CreateDocument-7.png';
import CreateDocument8 from './../../assets/CreateDocument-8.png';
import CreateDocument9 from './../../assets/CreateDocument-9.png';
import HelpFooter from './HelpFooter';
import useStyles from './useStyles';
import { useTranslation } from 'react-i18next';

export default function CreateDocument() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Breadcrumb
        name="topicName"
        data={{
          helpTopic: t('help.topics.documents.label'),
          helpTopicId: 'documents',
          topicName: t('help.subtopics.createDocumentWorkflow'),
          topicNameId: 'create-document-workflow'
        }}
      />
      <Typography className={classes.title} component="p" variant="h4">
        {t('help.pages.createDocumentWorkflow.title')}
      </Typography>
      <Typography variant="body1">{t('help.pages.createDocumentWorkflow.step1')}</Typography>
      <img className={classes.media} src={CreateDocument1} alt={`${String(t('help.stepAltPrefix'))}1`} />
      <Typography variant="body1">{t('help.pages.createDocumentWorkflow.step2')}</Typography>
      <img className={classes.media} src={CreateDocument2} alt={`${String(t('help.stepAltPrefix'))}2`} />
      <Typography variant="body1">{t('help.pages.createDocumentWorkflow.step3')}</Typography>
      <img className={classes.media} src={CreateDocument3} alt={`${String(t('help.stepAltPrefix'))}3`} />
      <Typography variant="body1">{t('help.selectDocumentRevision')}</Typography>
      <img className={classes.media} src={CreateDocument4} alt={`${String(t('help.stepAltPrefix'))}4`} />
      <Typography variant="body1">{t('help.pages.createDocumentWorkflow.step5')}</Typography>
      <img className={classes.media} src={CreateDocument5} alt={`${String(t('help.stepAltPrefix'))}5`} />
      <Typography variant="body1">{t('help.pages.createDocumentWorkflow.step6')}</Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        <u>{t('help.privacyDefinition')}</u>
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.privacy.public')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.privacy.encOnly')}
      </Typography>
      <img className={classes.media} src={CreateDocument6} alt={`${String(t('help.stepAltPrefix'))}6`} />
      <Typography variant="body1">{t('help.pages.createDocumentWorkflow.step7')}</Typography>
      <img className={classes.media} src={CreateDocument7} alt={`${String(t('help.stepAltPrefix'))}7`} />
      <Typography variant="body1">{t('help.pages.createDocumentWorkflow.step8')}</Typography>
      <img className={classes.media} src={CreateDocument8} alt={`${String(t('help.stepAltPrefix'))}8`} />
      <Typography variant="body1">{t('help.pages.createDocumentWorkflow.step9')}</Typography>
      <img className={classes.media} src={CreateDocument9} alt={`${String(t('help.stepAltPrefix'))}9`} />
      <HelpFooter />
    </div>
  );
}
